import React from 'react';
import { Slash, Save, AlertTriangle } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { useRef, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { startEditServicio } from '../../../../../app/store/catalagos/thunks';
export const EditServicio = () => {

    const { servicio_edit } = useSelector(state => state.catalogos);
    const { status, isLoading, productosAlm } = useSelector(state => state.catalogos);
    const closeModalEdit = useRef(null);
    const dispatch = useDispatch();

    const solo_num = (e) => {
        const allowedKeys = [
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Enter', 'Decimal', '.'
        ];

        const inputValue = e.target.value;
        const hasDecimal = inputValue.includes('.');

        // Si ya existe un punto decimal, solo permitir dos dígitos después de él
        if (hasDecimal && inputValue.split('.')[1].length >= 2 && (e.key >= '0' && e.key <= '9')) {
            e.preventDefault(); // Evitar más de 2 dígitos después del punto decimal
            return;
        }

        if (
            (e.key >= '0' && e.key <= '9') || // Números
            allowedKeys.includes(e.key) // Otras teclas permitidas
        ) {
            return true;
        } else {
            e.preventDefault(); // Evitar cualquier otra tecla
        }
    };


    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({
        defaultValues: {
            editnombreServicio: "",
            editcostoServicio: "",
            editcomisionRecepcionista: "",
            editcomisionTecnico: "",
            edittiempoDemoraServicio: "",
            editdescripcionServicio: "",
        }
    });


    useEffect(() => {

        setValue("editnombreServicio", servicio_edit.NOMBRE);
        setValue("editcostoServicio", servicio_edit.COSTO_SERV);
        setValue("editcomisionRecepcionista", servicio_edit.COMISION_REP);
        setValue("editcomisionTecnico", servicio_edit.COMISION_TEC);
        setValue("edittiempoDemoraServicio", servicio_edit.HR_REALIZAR);
        setValue("editdescripcionServicio", servicio_edit.DESCRIPCION);
        setValue("garantiaServicio", servicio_edit.GARANTIA);
        setValue("tiempoGarantiaServicio", servicio_edit.DIAS_GARANTIA);
        setValue("cantReqServicio", servicio_edit.CANTIDAD_PROD);
        setValue("editcostoServicioHDL", servicio_edit.COSTO_SERVICIO_HDL);
        setValue("prodReqServicio", servicio_edit.PRODUCTO_ID);

    }, [servicio_edit]);


    const handleEditServicio = (data) => {
        let id = servicio_edit.ID;
        dispatch(startEditServicio(data, id));
    }

    const clearForm = () => {
        reset();
    }


    useEffect(() => {
        if (status == 'Servicios Obtenidos') {
            reset();
        }
    }, [status])

    if (status == 'Servicios Obtenidos') closeModalEdit.current.click();

    // let prod = "";
    // productosAlm.forEach(element => {
    //     if(element.ID == servicio_edit.PRODUCTO_ID){
    //         // console.log(element);
    //         prod = ;


    //     }


    // });

    // console.log(prod);
    // // document.getElementById('text_prod').value=prod;

    return (
        <div className="modal fade" id="editService" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog ">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Editar Servicio: <span className='fw-bold'>{servicio_edit.NOMBRE}</span> </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={clearForm}></button>
                    </div>

                    <form onSubmit={handleSubmit(handleEditServicio)}>
                        <div className="modal-body">


                            {
                                isLoading ? <>

                                    <div className='text-center'>
                                        <div className="spinner"></div>
                                    </div>

                                </> : <>
                                    <div className="row">

                                        <div className='col-12 '>
                                            <div className="row">

                                                <div className="col-12">
                                                    <div className="mb-2">
                                                        <label className="form-label">Servicio:</label>
                                                        <input type="text" className="form-control" aria-label="First name" autoComplete='off' {...register("editnombreServicio", { required: 'Nombre del Servicio es requerido.', minLength: { value: 5, message: 'El nombre debe contener minimo 5 caracteres' } })} />
                                                        {
                                                            errors.editnombreServicio &&
                                                            <div className='text-left-5 mt-2'>
                                                                <AlertTriangle size="18" color="#dc3545" />
                                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.editnombreServicio.message}</small></span>
                                                            </div>
                                                        }

                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="mb-2">
                                                        <label className="form-label">Costo Serv:</label>
                                                        <input type="number" className="form-control" aria-label="First name" onKeyDown={solo_num} min={0} autoComplete='off' {...register("editcostoServicio", { required: 'Precio del Servicio es requerido.' })} />
                                                        {
                                                            errors.editcostoServicio &&
                                                            <div className='text-left-5 mt-2'>
                                                                <AlertTriangle size="18" color="#dc3545" />
                                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.editcostoServicio.message}</small></span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-6">
                                                    <div className="mb-2">
                                                        <label className="form-label">Costo Servicio (HDL):</label>
                                                        <input type="number" className="form-control" aria-label="First name" onKeyDown={solo_num} min={0} autoComplete='off' {...register("editcostoServicioHDL", { required: 'Costo del Servicio es requerido.' })} />
                                                        {
                                                            errors.editcostoServicioHDL &&
                                                            <div className='text-left-5 mt-2'>
                                                                <AlertTriangle size="18" color="#dc3545" />
                                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.editcostoServicioHDL.message}</small></span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div style={{ display: 'none' }} className="col-6">
                                                    <div className="mb-2">
                                                        <label className="form-label">Comision Recepcionista:</label>
                                                        <input type="number" className="form-control" aria-label="First name" onKeyDown={solo_num} min={0} disabled {...register("editcomisionRecepcionista", { required: 'C. para la Recep. es requerido' })} />
                                                        {
                                                            errors.editcomisionRecepcionista &&
                                                            <div className='text-left-5 mt-2'>
                                                                <AlertTriangle size="18" color="#dc3545" />
                                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.editcomisionRecepcionista.message}</small></span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div style={{ display: 'none' }} className="col-6">
                                                    <div className="mb-2">
                                                        <label className="form-label">Comision Tecnico:</label>
                                                        <input type="number" className="form-control" aria-label="First name" onKeyDown={solo_num} min={0} disabled {...register("editcomisionTecnico", { required: 'C. para el Tecnico es requerido' })} />
                                                        {
                                                            errors.editcomisionTecnico &&
                                                            <div className='text-left-5 mt-2'>
                                                                <AlertTriangle size="18" color="#dc3545" />
                                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.editcomisionTecnico.message}</small></span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-6">
                                                    <div className="mb-2">
                                                        <label className="form-label">Tiempo p/ realizar:</label>
                                                        <input type="number" className="form-control" aria-label="First name" onKeyDown={solo_num} min={0} {...register("edittiempoDemoraServicio", { required: 'Tiempo p/ realizar es requerido' })} />
                                                        {
                                                            errors.edittiempoDemoraServicio &&
                                                            <div className='text-left-5 mt-2'>
                                                                <AlertTriangle size="18" color="#dc3545" />
                                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.edittiempoDemoraServicio.message}</small></span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="mb-2">
                                                        <label className="form-label">Descripción:</label>
                                                        <textarea className="form-control" rows="3"
                                                            {...register('editdescripcionServicio', {
                                                                required: 'La descripción del Puesto es requerido.',
                                                                minLength: { value: 10, message: 'La Descripción debe contener por los menos 10 caracteres' },
                                                                maxLength: { value: 200, message: 'La Descripción debe contener maximo 200 caracteres' }
                                                            })}></textarea>
                                                        {
                                                            errors.editdescripcionServicio &&
                                                            <div className='text-left-20 mt-2'>
                                                                <AlertTriangle size="18" className='text-danger' />
                                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.editdescripcionServicio.message}</small></span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="mb-2">
                                                        <label className="form-label">Terminos de Garantia:</label>
                                                        <textarea className="form-control" rows="4"
                                                            {...register('garantiaServicio', {
                                                                required: 'Los Term. de garantia es requerido.',
                                                                minLength: { value: 10, message: 'Los Term. de Garantia deben contener por los menos 10 caracteres' },
                                                                // maxLength: { value: 200, message: 'La Descripción debe contener maximo 200 caracteres' }
                                                            })}></textarea>
                                                        {
                                                            errors.garantiaServicio &&
                                                            <div className='text-left-20 mt-2'>
                                                                <AlertTriangle size="18" className='text-danger' />
                                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.garantiaServicio.message}</small></span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-3">
                                                    <div className="mb-2">
                                                        <label className="form-label">Dias garantia:</label>
                                                        <input type="number" className="form-control" aria-label="First name" onKeyDown={solo_num} min={0} {...register("tiempoGarantiaServicio", { required: 'Dias de garantia es requerido' })} />
                                                        {
                                                            errors.tiempoGarantiaServicio &&
                                                            <div className='text-left-5 mt-2'>
                                                                <AlertTriangle size="18" color="#dc3545" />
                                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.tiempoGarantiaServicio.message}</small></span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-6">
                                                    <div className="mb-2">
                                                        <label className="form-label">Producto de Inventario:</label>
                                                        <select className="form-select" {...register("prodReqServicio")}>
                                                            <option value={'0'}>Seleccione producto</option>
                                                            {/* {
                                                                productosAlm.map((item, index) => (
                                                                    item.ESTADO == 1 ? <option key={index} value={item.ID} className='text-uppercase' > {item.DESCRIPCION} - {item.MODELO}</option>
                                                                        : <option key={index} style={{ display: "none" }} ></option>
                                                                ))
                                                            } */}
                                                            {
                                                                productosAlm.map((item, index) => (
                                                                    item.ACTIVE != 0 && item.TYPE_PRODUCT != 2 ? <option key={index} value={item.ID} className='text-uppercase' > {item.NAME_PRODUCT} - {item.DESCRIPTION_PRODUCT}</option>
                                                                        : <option key={index} style={{ display: "none" }} ></option>
                                                                ))
                                                            }
                                                        </select>
                                                        {
                                                            errors.prodReqServicio &&
                                                            <div className='text-left-5 mt-2'>
                                                                <AlertTriangle size="18" color="#dc3545" />
                                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.prodReqServicio.message}</small></span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-3">
                                                    <div className="mb-2">
                                                        <label className="form-label">Cant. Req:</label>
                                                        <input type="number" className="form-control" aria-label="First name" onKeyDown={solo_num} min={0} {...register("cantReqServicio")} />
                                                        {
                                                            errors.cantReqServicio &&
                                                            <div className='text-left-5 mt-2'>
                                                                <AlertTriangle size="18" color="#dc3545" />
                                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.cantReqServicio.message}</small></span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>





                                            </div>
                                        </div>
                                    </div></>
                            }


                        </div>
                        <div className="modal-footer">
                            <button type="button" ref={closeModalEdit} hidden className="btn btn-secondary" data-bs-dismiss="modal" >CERRAR</button>
                            <button type="button" className="btn btn-outline-danger" data-bs-dismiss="modal" onClick={clearForm}>
                                <Slash size="20" />  Cancelar
                            </button>
                            <button type="submit" className="btn btn-outline-primary" >
                                <Save size="20" />  Guardar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    )
}
